<template>
  <div class="tipo">
    <div class="centro">
      <h1>Consulta por Autor</h1>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cardsLegislacao" />
      <p>
        <strong>Importante:</strong> A informação do Autor está disponível
        apenas para as legislações com data de 01/01/2019 em diante.
      </p>
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelBuscaSimplificada
        :dados="autoresFormatados"
        :generateUrl="generateUrl"
        titulo="Autores"
        :exibirIndice="true"
        :idProIndice="generateId"
        v-if="!carregando && !erro"
      />
    </div>
  </div>
</template>

<script>
import LegislacaoApi from "../../services/LegislacaoApi";
import Loading from "../../components/Loading";
import ErroResultados from "../../components/ErroResultados";
import PainelBuscaSimplificada from "../../components/PainelBuscaSimplificada";
import { mixinLegislacao } from "../../mixins/mixinLegislacao";

import metaDados from "../../helpers/metaDados";

export default {
  name: "PorAutor",
  metaInfo() {
    return {
      title: "Pesquisa de Legislação por Autor",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Pesquisa a Legislação por Autor- Casa Civil do Estado de Goiás",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Pesquisa a Legislação por Autor - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinLegislacao],
  data() {
    return {
      carregando: true,
      erro: false,
      autores: [],
      filtro: {
        autor: null,
        ano: null,
      },
    };
  },
  computed: {
    // Parte para formatar os números com separador milhar.
    autoresFormatados() {
      return this.autores.map((autor) => {
        return {
          ...autor,
          quantidade: autor.quantidade_total,
        };
      });
    },
  },
  components: {
    PainelBuscaSimplificada,
    Loading,
    ErroResultados,
  },
  created() {
    this.legislacaoApi = new LegislacaoApi();

    this.carregarAutores();
  },
  methods: {
    carregarAutores: async function () {
      try {
        if (this.legislacaoApi.cancelTokens.getAutores) {
          this.legislacaoApi.cancelTokens.getAutores.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.autores = await this.legislacaoApi.getAutores();
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl(ano, dados) {
      this.filtro.autor = dados.nome;
      this.filtro.ano = ano;

      this.$router.push({
        name: "PesquisaLegislacao",
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          busca_avancada: 1,
        },
      });
    },
    generateId: function (dado) {
      if (dado.nome && /DEP. /.test(dado.nome)) {
        const groups = dado.nome.match(/DEP. (?<nome>.+)/).groups;
        if (groups.nome) {
          return groups.nome[0];
        }
      } else if (dado.nome) {
        return dado.nome[0];
      }
      return "";
    },
    formatNumber(number) {
      // Método para formatar os números com separador milhar.
      if (number) return number.toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #115810;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}

p {
  margin: 1rem 1.5rem 1rem 0.5rem;
  font-size: 0.9rem;
  letter-spacing: 0.03rem;
  strong {
    text-transform: uppercase;
  }
}
.alto-contraste {
  p {
    color: white;
  }
}
</style>
